import 'twin.macro';
import React from 'react';
import { DocumentTextIcon as DocumentText } from '@heroicons/react/24/outline';
import { IconProps } from '@teetsh/app/src/components/Icons/icon';
import { tagBackgroundColors, tagTextColor } from 'styles/userConstants';
import { css } from 'twin.macro';

export function FDPIcon(props: IconProps) {
  return (
    <DocumentText
      tw="p-1 rounded-lg"
      css={[
        css`
          background-color: ${tagBackgroundColors['lavande-quiet']};
          color: ${tagTextColor.lavande};
        `,
      ]}
      className={props.className}
      {...props}
    />
  );
}
